import { pathgen } from 'object-path-generator';
export const HelpMeWriteTextFieldTestIds = pathgen('HelpMeWriteTextFieldTestIds');
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["Formalize"] = "Formalize";
  ActionType["Polish"] = "Polish";
  ActionType["Elaborate"] = "Elaborate";
  ActionType["Shorten"] = "Shorten";
  return ActionType;
}({});